var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportResultTable',{attrs:{"card_title":_vm.card_title,"reportname":"FinanceReport","reportdata":_vm.reportdata,"rowtemplates":_vm.rowtemplates,"nopage":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }